import {
  useQuery,
  useMutation,
  useQueryClient,
  type QueryKey,
} from '@tanstack/react-query';
import service from '@Service';
import type { AgentOperation } from '@Types/agent';

export const agentOperationKeys = {
  forSoul: (soulId: string) => ['agent-operations', soulId] as const,
};

export function useAgentOperations({
  soulId,
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  return useQuery<AgentOperation[]>({
    queryKey: agentOperationKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getAgentOperations(soulId!),
    enabled: enabled && !!soulId,
  });
}

export function useAssignOperation(soulId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (operation: string) =>
      service.createAgentOperation(soulId, operation),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: agentOperationKeys.forSoul(soulId),
      }),
  });
}

export function useRemoveOperation(soulId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (operationId: string) =>
      service.deleteAgentOperation(soulId, operationId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: agentOperationKeys.forSoul(soulId),
      }),
  });
}
